import { BLOCK_META_CORE, BLOCKS_CORE } from '@/blocks/registry-core'
import type { BlockConfig, BlockMeta } from '@/blocks/types'

/**
 * All block configs keyed by block type. The execution source of truth.
 *
 * Seeded with the core set and extended in place when the integration
 * catalogue lands (`lib/ondit/integration-catalogue`). Readers go through the
 * accessors in `registry.ts`, which look the map up on every call, so a lookup
 * that missed before the chunk arrived answers once it has.
 */
export const BLOCK_REGISTRY: Record<string, BlockConfig> = { ...BLOCKS_CORE }

/**
 * Presentation meta for catalog-visible integrations, keyed like the registry
 * above and extended with it. `BlockMeta` exists only for catalog-visible
 * integrations — every key here has a corresponding entry in
 * `packages/deployment-config/src/integrations.json`.
 */
export const BLOCK_META_REGISTRY: Record<string, BlockMeta> = { ...BLOCK_META_CORE }

/** Adds the catalogue's entries; the loader calls this exactly once. */
export function extendBlockRegistry(
  blocks: Record<string, BlockConfig>,
  meta: Record<string, BlockMeta>
): void {
  Object.assign(BLOCK_REGISTRY, blocks)
  Object.assign(BLOCK_META_REGISTRY, meta)
}
